export type ChatScrollPosition = {
	top: number;
	atBottom: boolean;
};

const positions = new Map<string, ChatScrollPosition>();

export const saveChatScrollPosition = (sessionId: string, position: ChatScrollPosition) => {
	positions.set(sessionId, position);
};

export const getChatScrollPosition = (sessionId: string): ChatScrollPosition | undefined => positions.get(sessionId);
